"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AfterEffectsChapterType = void 0;
var AfterEffectsChapterType;
(function (AfterEffectsChapterType) {
    AfterEffectsChapterType["Video"] = "Video";
    AfterEffectsChapterType["Image"] = "Image";
    AfterEffectsChapterType["TemplatePreRoll"] = "TemplatePreRoll";
    AfterEffectsChapterType["TemplatePostRoll"] = "TemplatePostRoll";
    AfterEffectsChapterType["Student"] = "Student";
    AfterEffectsChapterType["Ceremony"] = "Ceremony";
})(AfterEffectsChapterType = exports.AfterEffectsChapterType || (exports.AfterEffectsChapterType = {}));
//# sourceMappingURL=after-effects-chapter-type.js.map